import Box from '@mui/material/Box';
import { colorPalette } from '@repo/mui-config/color-palette';
import type { Children } from '@repo/shared/types';

interface AdvanceAmountEditPreviewWrapperProps extends Children {
  testId: string;
}

export function AdvanceAmountEditPreviewWrapper({
  children,
  testId,
}: AdvanceAmountEditPreviewWrapperProps) {
  return (
    <Box
      data-testid={testId}
      sx={{
        backgroundColor: colorPalette.primary.light,
        borderRadius: '10px',
        p: 3,
        paddingBottom: '18px',
        minHeight: '172px',
      }}
    >
      {children}
    </Box>
  );
}
